import { useForm } from '@/common/form/FormContext';
import { EntitySelect } from '@/common/form/formFields/EntitySelect';
import { useEffect, useMemo } from 'react';

export const CtrtOwnerCust = ({ ctrtTypeIdToCode, fieldDef }) => {
  const { formValues, assignValue } = useForm();

  const ctrtTypeNoOwner = ['MCD', 'MPD'];
  const ctrtTypeCode = ctrtTypeIdToCode[formValues.typeId];
  const noOwner = ctrtTypeNoOwner.includes(ctrtTypeCode);

  useEffect(() => {
    if (noOwner) {
      assignValue('ownerCustId', null);
      assignValue('ownerCustCode', null);
    }
  }, [formValues.typeId]);

  const updatedFieldDef = useMemo(() => {
    return {
      ...fieldDef,
      disabled: fieldDef.disabled || noOwner,
      required: !noOwner,
    };
  }, [formValues.typeId, fieldDef.disabled]);

  return <EntitySelect fieldDef={updatedFieldDef} />;
};
